import Internal from './Internal';

export default Internal;
